/**
 * Representative groups (tipologjitë e përfaqësuesve). Independent of the role: the role says
 * what someone may do in the platform, the group says what kind of work is expected from them,
 * and so which activity categories they see. See docs/03-roles-and-permissions.md#groups.
 */
export const UserGroup = {
    /** Të zgjedhurit në institucione: deputetë, kryetarë bashkie, këshilltarë bashkiakë e qarkorë. */
    ELECTED: 'ELECTED',
    /** Përfaqësuesit në terren: kryetarë degësh, sekretarë politikë e organizativë, kryetarë seksionesh. */
    FIELD: 'FIELD',
    /** Përfaqësuesit qendrorë: Kryesia, sekretarët, Këshilli Kombëtar, drejtuesit e departamenteve. */
    CENTRAL: 'CENTRAL',
    /** Funksionarët e partisë: stafi i selisë dhe strukturat e organizimit. */
    STAFF: 'STAFF',
    /** Përfaqësuesit e diasporës: their activities take place abroad (country and city). */
    DIASPORA: 'DIASPORA',
};
export const USER_GROUPS = Object.values(UserGroup);
/**
 * Categories with no group are offered to everyone; otherwise only to members of those groups.
 * People without a group (e.g. administrators) see every category.
 */
export function categoryVisibleTo(categoryGroups, group) {
    return !group || categoryGroups.length === 0 || categoryGroups.includes(group);
}
//# sourceMappingURL=group.js.map